import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-drp-dashboard',
  templateUrl: './drp-dashboard.component.html',
})
export class DrpDashboardComponent {
  data: any = {};
  loading$ = new BehaviorSubject(true);
  @Input() patient;
}
